module.exports = __webpack_public_path__ + "website/img/zs2.ba0d5aee.jpeg";